export default {
	user: null,
  users: [],
  newUser: null,
	error: false,
	loader: false
};